import { registerOpenBlotterFlexiForwardTradeCaptureListener } from '@/store/flexi-forward/listeners/blotter-open-trade-capture-listener.ts';
import { registerDuplicateFlexiForwardTradeCaptureListeners } from '@/store/flexi-forward/listeners/duplicate-flexi-forward-trade-capture-listeners.ts';
import { registerRfsFlexiForwardListeners } from '@/store/flexi-forward/listeners/rfs-listener.ts';
import { registerTabListenersForFlexiForward } from '@/store/flexi-forward/listeners/tab-listener.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';

export function registerFlexiForwardListeners(startAppListening: StartAppListening): void {
  registerTabListenersForFlexiForward(startAppListening);
  registerDuplicateFlexiForwardTradeCaptureListeners(startAppListening);
  registerRfsFlexiForwardListeners(startAppListening);
  registerOpenBlotterFlexiForwardTradeCaptureListener(startAppListening);
}
